const ENGLISH_LANGUAGE = 'en-us';

export const LANGUAGES = {
    EN_EN: ENGLISH_LANGUAGE,
    DEFAULT: ENGLISH_LANGUAGE,
};

export const LANGUAGE_FILES = {
    BASE: 'base',
    MODERATION: 'moderation',
    ANALYTICS: 'analytics',
};
